import { render, staticRenderFns } from "./CustomFonts.vue?vue&type=template&id=9a1c19fa"
import script from "./CustomFonts.vue?vue&type=script&lang=js"
export * from "./CustomFonts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports